import { render, staticRenderFns } from "./GlobalMonthlyResumeCredit.vue?vue&type=template&id=8d4fa4bc&"
import script from "./GlobalMonthlyResumeCredit.vue?vue&type=script&lang=js&"
export * from "./GlobalMonthlyResumeCredit.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMonthlyResumeCredit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports